<template>
    <div class="container">
        <div class="error404 mincho">
            <div>404</div>
            ページが見つかりません。
            <p>{{path}}</p>
            <p>
                <router-link to="/">トップへ戻る</router-link>
            </p>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.error404 {
    font-size: 5rem;
    text-align: center;
    margin-top: 20%;
    padding: 2rem;
    border: 11px solid #1e008b;
    border-radius: 1.5rem;
    color: #1e008b;
    p {
        font-size: 2rem;
    }
}
</style>

<script>
export default {
    data() {
        return {
            path: null,
        }
    },
    created() {
        this.path = this.$route.path;
    }
}
</script>